var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("ModalTokenConfirm", {
        attrs: {
          show: _vm.preparedModal.show,
          title: _vm.$t("message.modal_confirm_token_title"),
          content: _vm.$t("message.modal_confirm_token_text"),
          cancel: _vm.$t("message.modal_confirm_token_cancel_button"),
          confirm: _vm.$t("message.modal_confirm_token_confirm_button")
        },
        on: {
          close: function($event) {
            _vm.preparedModal.show = false
          },
          confirm: function($event) {
            _vm.removeToken($event, true)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("message.my_token")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.token_description_1")) +
                "\n        "
            ),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.gs1-germany.de/serviceverzeichnis/verified-by-gs1/",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v(_vm._s(_vm.$t("message.registry_platform")))]
            ),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.before_swagger_link")) +
                "\n        "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "/api/verified_service/swagger-ui/index.html",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v(_vm._s(_vm.$t("message.token_description_3")))]
            ),
            _vm._v(
              ".\n        " +
                _vm._s(_vm.$t("message.token_description_2")) +
                "\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row", staticStyle: { margin: "1% 0" } }, [
        _c(
          "div",
          { staticClass: "col-md-6", staticStyle: { "padding-left": "0" } },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-xs",
                class: "btn-primary",
                attrs: {
                  role: "button",
                  tag: "button",
                  title: _vm.$t("message.token_tooltip")
                },
                on: { click: _vm.createToken }
              },
              [
                _c("span", { staticClass: "glyphicon glyphicon-plus" }),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.create_new_token")) +
                    "\n      "
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 text-right" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-xs",
              attrs: {
                type: "button",
                href:
                  _vm.SIMBA_SERVICE_BASE_URL +
                  "/api/verified_service/swagger-ui/index.html",
                target: "_blank",
                role: "button",
                tag: "button",
                title: _vm.$t("message.api_docs_tooltip")
              }
            },
            [
              _vm._v("API Docs "),
              _c("span", { staticClass: "glyphicon glyphicon-search" })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "inline" } }, [
        _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "small table table-striped" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v(_vm._s(_vm.$t("message.token_id")))
                  ])
                ]),
                _vm._v(" "),
                _c("th", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v(_vm._s(_vm.$t("message.username")))
                  ])
                ]),
                _vm._v(" "),
                _c("th", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v(_vm._s(_vm.$t("message.comapany_name")))
                  ])
                ]),
                _vm._v(" "),
                _c("th", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v(_vm._s(_vm.$t("message.tokens")))
                  ])
                ]),
                _vm._v(" "),
                _c("th", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v(_vm._s(_vm.$t("message.revocation")))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.tokens.length == 0
              ? _c("tbody", [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "text-center text-muted",
                        attrs: { colspan: "8" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("message.no_token_found")) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ])
              : _vm.loading
              ? _c("tbody", [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "text-center text-muted",
                        attrs: { colspan: "8" }
                      },
                      [
                        _c("i", { staticClass: "fas fa-spinner fa-spin" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("message.loading")) +
                            "\n            "
                        )
                      ]
                    )
                  ])
                ])
              : _c(
                  "tbody",
                  _vm._l(_vm.tokens, function(token, index) {
                    return _c("tr", { key: token.id }, [
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(token.id) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(token.username) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(token.companyName) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("input", {
                          staticStyle: { width: "381px" },
                          attrs: { readonly: "" },
                          domProps: { value: token.token }
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "clipboard",
                                rawName: "v-clipboard",
                                value: function() {
                                  return token.token
                                },
                                expression: "() => token.token"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("message.copy")) +
                                "\n              "
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "trashIconContainer",
                          attrs: { scope: "row" }
                        },
                        [
                          _c("i", {
                            staticClass: "far fa-trash-alt",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.deleteToken(index, token.id)
                              }
                            }
                          })
                        ]
                      )
                    ])
                  })
                )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-052ac06a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052ac06a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/Token.vue
// module id = null
// module chunks = 